// extracted by mini-css-extract-plugin
export default {"root":"bzgsh","rotate":"RGDAu","center":"_3Zcvk","rotateOnCenter":"_5Vxim"};